export class RequiredSynchedStates {

  static menuReloadNumber = "MySynchedStates.menuReloadNumber"
  static navigationHistory = "MySynchedStates.navigationHistory"
  static showCookies = "RequiredSynchedStates.ShowCookies"

}
